export default __webpack_public_path__ + "static/media/three_stone.2cf6161f.webp";